import axios from "axios";
import {useCallback, useState} from "react";
import jsonp from "jsonp";

export async function defaultPostRequest(endpoint, body) {
    const result = await axios
        .post(endpoint, body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log('error ', error)
            return false;
        });
    return result;
}


export async function protectedEnpointPostRequest(endpoint, body, token) {
    const result = await axios
        .post(endpoint, body, {
            headers: {
                // "Content-Type": "application/json",
                "content-type": "application/json",
                "Accept": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.log(error);
            return false;
        });
    return result;
}


export const Status = {
    idle: 'IDLE',
    loading: 'LOADING',
    success: 'SUCCESS',
    error: 'ERROR'
}

function toQueryString(params) {
    return Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
}

export const useMailChimp = (url) => {
    const [status, setStatus] = useState(Status.idle);
    const [error, setError] = useState(null);
    const [value, setValue] = useState(null);

    const subscribe = useCallback((data) => {
        const params = toQueryString(data);
        const ajaxURL = url.replace("/post?", "/post-json?");
        const newUrl = ajaxURL + "&" + params;

        setError(null);
        setStatus(Status.loading);

        jsonp(newUrl, { param: "c" }, (err, data) => {
            console.log('err ',err)
            console.log('data ',data)
            if (err) {
                setStatus(Status.error);
                setError(err);
            } else if (data.result !== "success") {
                setStatus(Status.error);
                setError(data.msg);
            } else {
                console.log('err ',err)
                console.log('data ',data)
                setStatus(Status.success);
                setValue(data.msg);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { subscribe, status, error, value };
}
